import { render, staticRenderFns } from "./JianduList.vue?vue&type=template&id=0ab8d294&scoped=true&"
import script from "./JianduList.vue?vue&type=script&lang=js&"
export * from "./JianduList.vue?vue&type=script&lang=js&"
import style0 from "./JianduList.vue?vue&type=style&index=0&id=0ab8d294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8d294",
  null
  
)

export default component.exports